var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to-top",attrs:{"id":"btnToTop"}},[_c('button',{staticClass:"btn-to-top",on:{"click":_vm.toTop}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'angle-up']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }